import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base';
import Utils from '../js/utils';
import moment from 'moment';
import Employee from '../js/employee';
var Home = {
  pn: 'div[data-name="home"]',
  init: function () {
    var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(today) {
      var self, $input;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = this;
              self.showBranches();
              self.getCalendar(today);
              $input = $('#home-selected-date');
              Base.app.calendar.create({
                inputEl: $input,
                dateFormat: 'd/m/yyyy'
              });
              $input.change(function () {
                self.reset();
                self.getCalendar($(this).val());
              });
              $(self.pn + ' .employees-list .title').click(function () {
                self.backEmpToList();
              });
              $(self.pn + ' .employees-dayoff .title').click(function () {
                var status = $(this).parent().attr('data-status');
                self.dayoffClick(status);
              });
              $('#home-copyfromlast-button').click(function () {
                self.copyFromLast($input.val());
              });
              $(self.pn + ' textarea[name="note"]').change(function () {
                self.saveNote($(this).val());
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function init(_x) {
      return _init.apply(this, arguments);
    }

    return init;
  }(),
  saveNote: function () {
    var _saveNote = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(note) {
      var self, selected_date, preloader, rs;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(note.trim() == '')) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", false);

            case 2:
              self = this;
              selected_date = self.getSelectedDate();
              preloader = Base.app.dialog.preloader();
              _context2.next = 7;
              return Base.api('WorkingCalendar', 'note', {
                note: note,
                selected_date: selected_date
              });

            case 7:
              rs = _context2.sent;
              preloader.close();
              Utils.notiInfo('Ghi chú đã được lưu lại');

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function saveNote(_x2) {
      return _saveNote.apply(this, arguments);
    }

    return saveNote;
  }(),
  reset: function reset() {
    var self = this;
    $(self.pn + ' .branch .employees').html('');
    $(self.pn + ' .employees-list .list').html('');
    $(self.pn + ' .employees-dayoff[data-status="0"] .list').html('');
    $(self.pn + ' .employees-dayoff[data-status="1"] .list').html('');
  },
  getSelectedDate: function getSelectedDate() {
    return $('#home-selected-date').val();
  },
  copyFromLast: function copyFromLast(selected_date) {
    var self = this;

    var doit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var preloader, rs;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                self.reset();
                preloader = Base.app.dialog.preloader();
                _context3.next = 4;
                return Base.api('WorkingCalendar', 'copyFromLast', {
                  selected_date: selected_date
                });

              case 4:
                rs = _context3.sent;
                preloader.close();
                self.displayCalendar(rs);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function doit() {
        return _ref.apply(this, arguments);
      };
    }();

    Base.app.dialog.confirm('Copy dữ liệu từ ngày gần nhất? Việc này sẽ xoá toàn bộ dữ liệu hiện tại', 'Xác nhận', doit);
  },
  showBranches: function showBranches() {
    var self = this;
    Base.branches.forEach(function (item, i) {
      var count = i + 1;
      var b = $("<div class=\"branch\" data-id=\"".concat(item.id, "-").concat(item.work_shift, "\">\n                  <div class=\"name\">").concat(item.name, "</div>\n                  <div class=\"employees\"></div>\n                </div>"));
      b.find('.name').click(function () {
        self.addEmpToBranch($(this).parent().attr('data-id'));
      });
      $(self.pn + ' .branches').append(b);

      if (count % 2 === 0 || count == Base.branches.length) {
        $(self.pn + ' .branches').append('<div class="clearfix"></div>');
      }
    });
  },
  dayoffClick: function () {
    var _dayoffClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(status) {
      var self, dataset, working_date, loading, rs;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              self = this;
              dataset = [];
              $(self.pn + ' .emp.selected').each(function () {
                var item = $(this).data('data');
                var $emp = self.makeEmp(item);
                $(self.pn + " .employees-dayoff[data-status=\"".concat(status, "\"] .list")).append($emp);
                var datarow = {};
                datarow.id_emp = item.id_emp;
                datarow.id_branch = null;
                datarow.work_shift = null;
                datarow.status = status == "1" ? 1 : null;
                dataset.push(datarow);
                $(this).remove();
              });

              if (!(dataset.length == 0)) {
                _context4.next = 5;
                break;
              }

              return _context4.abrupt("return", false);

            case 5:
              working_date = self.getSelectedDate();
              loading = Base.app.dialog.preloader('Đang xử lý...');
              _context4.next = 9;
              return Base.api('WorkingCalendar', 'save', {
                dataset: dataset,
                working_date: working_date
              });

            case 9:
              rs = _context4.sent;
              loading.close();

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function dayoffClick(_x3) {
      return _dayoffClick.apply(this, arguments);
    }

    return dayoffClick;
  }(),
  backEmpToList: function () {
    var _backEmpToList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var self, dataset, working_date, loading, rs;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              self = this;
              dataset = [];
              $(self.pn + ' .emp.selected').each(function () {
                var item = $(this).data('data');
                var $emp = self.makeEmp(item);
                $(self.pn + ' .employees-list .list').append($emp);
                var datarow = {};
                datarow.id_emp = item.id_emp;
                dataset.push(datarow);
                $(this).remove();
              });

              if (!(dataset.length == 0)) {
                _context5.next = 5;
                break;
              }

              return _context5.abrupt("return", false);

            case 5:
              working_date = self.getSelectedDate();
              loading = Base.app.dialog.preloader('Đang xử lý...');
              _context5.next = 9;
              return Base.api('WorkingCalendar', 'remove', {
                dataset: dataset,
                working_date: working_date
              });

            case 9:
              rs = _context5.sent;
              loading.close();

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function backEmpToList() {
      return _backEmpToList.apply(this, arguments);
    }

    return backEmpToList;
  }(),
  addEmpToBranch: function () {
    var _addEmpToBranch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(branch_id) {
      var self, dataset, id_branch, working_date, loading, rs, emps, conflicts, b;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              self = this;
              dataset = [];
              id_branch = 0;
              $(self.pn + ' .emp.selected').each(function () {
                var item = $(this).data('data');
                var $emp = self.makeEmp(item);
                $(self.pn + ' .branch[data-id="' + branch_id + '"] .employees').append($emp);
                var datarow = {};
                datarow.id_emp = item.id_emp;
                var a = branch_id.split('-');
                id_branch = a[0];
                datarow.id_branch = id_branch;
                datarow.work_shift = a[1];
                datarow.status = parseInt(Base.initdata.wcStatus.working);
                dataset.push(datarow);
                $(this).remove();
              });

              if (!(dataset.length == 0)) {
                _context6.next = 6;
                break;
              }

              return _context6.abrupt("return", false);

            case 6:
              working_date = self.getSelectedDate();
              loading = Base.app.dialog.preloader('Đang xử lý...');
              _context6.next = 10;
              return Base.api('WorkingCalendar', 'save', {
                dataset: dataset,
                working_date: working_date
              });

            case 10:
              rs = _context6.sent;
              loading.close(); //Check anti users

              emps = [];
              $(self.pn + ' .branch[data-id="' + branch_id + '"] .employees .emp').each(function () {
                var id = $(this).data('id');
                var anti = $(this).data('anti') != '' ? $(this).data('anti').split(',') : [];
                var name = $(this).text();
                emps.push({
                  id: id,
                  name: name,
                  anti: anti
                });
              });
              conflicts = [];
              emps.forEach(function (u1) {
                emps.forEach(function (u2) {
                  if (u1.id !== u2.id) {
                    if (u1.anti.includes(u2.id)) {
                      conflicts.push({
                        a: u1.name,
                        b: u2.name
                      });
                    }
                  }
                });
              });

              if (conflicts.length > 0) {
                b = Base.branches.find(function (b) {
                  return b.id == id_branch;
                }) || {};
                Base.app.dialog.alert(conflicts.map(function (u) {
                  return "<div>".concat(u.a, " >< ").concat(u.b, "</div>");
                }).join(''), b.name);
              }

            case 17:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function addEmpToBranch(_x4) {
      return _addEmpToBranch.apply(this, arguments);
    }

    return addEmpToBranch;
  }(),
  getCalendar: function () {
    var _getCalendar = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(selected_date) {
      var self, preloader, rs;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              self = this;
              preloader = Base.app.dialog.preloader();
              _context7.next = 4;
              return Base.api('WorkingCalendar', 'get', {
                selected_date: selected_date
              });

            case 4:
              rs = _context7.sent;
              preloader.close();
              self.displayCalendar(rs);

            case 7:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function getCalendar(_x5) {
      return _getCalendar.apply(this, arguments);
    }

    return getCalendar;
  }(),
  displayCalendar: function displayCalendar(rs) {
    var self = this;
    var $dayoff_0_Wrapper = $(self.pn + ' .employees-dayoff[data-status="0"] .list');
    var $dayoff_1_Wrapper = $(self.pn + ' .employees-dayoff[data-status="1"] .list');
    rs.rows.forEach(function (item, i) {
      var $emp = self.makeEmp(item);
      var status = Utils.str2Num(item.status);

      switch (status) {
        case 0:
          $dayoff_0_Wrapper.append($emp);
          break;

        case 1:
          $dayoff_1_Wrapper.append($emp);
          break;

        case 2:
          $(self.pn + " .branch[data-id=\"".concat(item.id_branch, "-").concat(item.work_shift, "\"] .employees")).append($emp);
          break;

        default:
          break;
      }
    });
    var note = rs.note ? rs.note.trim() : '';
    $(self.pn + ' textarea[name="note"]').val(note);
    self.displayEmpList(rs);
  },
  displayEmpList: function displayEmpList(rs) {
    var self = this;
    var ids = [];
    $(self.pn + ' .emp').each(function () {
      var id = $(this).attr('data-id');
      ids.push(parseInt(id));
    });
    var $empWrapper = $(self.pn + ' .employees-list .list');
    rs.emps.forEach(function (item, i) {
      var id = parseInt(item.id_emp);

      if (!ids.includes(id)) {
        var $emp = self.makeEmp(item);
        $empWrapper.append($emp);
      }
    });
  },
  makeEmp: function makeEmp(item) {
    var self = this;
    var deleted = '';
    if (item.deleted == 1) deleted = 'text-deleted';
    var $emp = $("<div class=\"chip emp unselected\" data-id=\"".concat(item.id_emp, "\" data-anti=\"").concat(item.anti_users, "\">\n                    <div class=\"chip-label ").concat(deleted, "\">").concat(item.name, "</div>\n                  </div>"));
    $emp.data('data', item);
    $emp.click(function () {
      if ($(this).hasClass('unselected')) {
        $(this).removeClass('unselected');
        $(this).addClass('selected');
      } else {
        $(this).removeClass('selected');
        $(this).addClass('unselected');
      }
    });
    $emp.on('taphold', function (evt) {
      $(self.pn + ' .emp').removeClass('selected');
      var $target = $(evt.currentTarget);
      var id_emp = parseInt($target.attr('data-id'));
      var name = $target.text();
      var selected_date = self.getSelectedDate();
      $target.removeClass('unselected');
      $target.addClass('selected');
      var a = selected_date.split('/');
      var thang = a[1];
      var nam = a[2];
      var item = {
        id_emp: id_emp,
        name: name,
        thang: thang,
        nam: nam
      };
      Base.app.actions.create({
        buttons: [{
          text: 'Tạm ứng',
          onClick: function onClick() {
            Employee.TamUng.openForm(item);
          }
        }, {
          text: 'Nghỉ không phép',
          onClick: function onClick() {
            Employee.unauthorizedAbsence(item);
          }
        }, {
          text: 'Nghỉ quá người',
          onClick: function onClick() {
            Employee.exceededAbsence(item);
          }
        }, {
          text: 'Thưởng/Phạt khác',
          onClick: function onClick() {
            Employee.ThuongPhat.openForm(item);
          }
        }, {
          text: 'Huỷ',
          color: 'red',
          onClick: function onClick() {
            $target.removeClass('selected');
            $target.addClass('unselected');
          }
        }]
      }).open();
    });
    return $emp;
  }
};
export default (function ($prop, ctx) {
  moment.locale('vi');
  var todaylabel = moment().format('dddd, Do MMMM YYYY');
  var today = moment().format(Base.dateFormat);
  ctx.$on('pageInit', function () {
    if (!Base.branchesLoaded) {
      var watch = setInterval(function () {
        if (Base.branchesLoaded) {
          clearInterval(watch);
          Home.init(today);
        }
      }, 500);
    } else {
      Home.init(today);
    }
  });

  var profile = function profile() {
    Base.profile();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="home">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left"><a href="#" data-panel=".panel-left" class="panel-open" id="menu-bars"><i class="f7-icons icon">bars</i></a></div>
        <div class="title sliding"><input id="home-selected-date" class="selected-date" value="${today}" readonly/></div>
        <div class="right"><a href="#" @click=${profile} id="login-button"><i class="f7-icons icon">person_circle</i></a></div>
      </div>
    </div>
    <div class="fab fab-right-bottom">
      <a href="#" id="home-copyfromlast-button"><i class="icon f7-icons" style="font-size: 14px;">rectangle_fill_on_rectangle_fill</i></a>
    </div>
    <div class="page-content">
      <div class="block-strong block text-align-center" style="margin: 5px; padding: 3px;">
        Hôm nay là ${todaylabel}
      </div>
      <div class="branches">
      </div>
      <div class="employees-dayoff" data-status="0">
        <div class="title">Xin nghỉ</div>
        <div class="list no-margin padding-2"></div>
      </div>
      <div class="employees-dayoff" data-status="1">
        <div class="title">Nghỉ</div>
        <div class="list no-margin padding-2"></div>
      </div>
      <div class="clearfix"></div>
      <div class="employees-list">
        <div class="title">Danh sách nhân viên</div>
        <div class="list no-margin padding-2"></div>
      </div>
      <div class="note">
        <div class="title">Ghi chú</div>
        <div class="no-margin padding-2">
          <textarea name="note" rows="3" style="width:100%;background-color:#333;" placeholder=""></textarea>
        </div>
      </div>

    </div>
  </div>
`
    }
    ;
});